import PostDetailSectionImplementation from '../implementation/sections/PostDetailSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiPostDetailSectionDTO,
  PostDetailSectionDTO,
} from '@lib/strapi/dtos/components/sections/postDetailSection.dto';

const PostDetailSection = (props: ComponentProps<PostDetailSectionDTO>) => {
  return <PostDetailSectionImplementation {...props}></PostDetailSectionImplementation>;
};

export default PostDetailSection;
